/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReportJudgmentDto
 */
export interface GetReportJudgmentDto {
    /**
     * 
     * @type {string}
     * @memberof GetReportJudgmentDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportJudgmentDto
     */
    psychologistName: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportJudgmentDto
     */
    psychologistId: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportJudgmentDto
     */
    registerName: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportJudgmentDto
     */
    registerId: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportJudgmentDto
     */
    healthcareFacilityName: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportJudgmentDto
     */
    healthcareFacilityId: string;
    /**
     * 
     * @type {number}
     * @memberof GetReportJudgmentDto
     */
    countJudgments: number;
}

/**
 * Check if a given object implements the GetReportJudgmentDto interface.
 */
export function instanceOfGetReportJudgmentDto(value: object): value is GetReportJudgmentDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('psychologistName' in value) || value['psychologistName'] === undefined) return false;
    if (!('psychologistId' in value) || value['psychologistId'] === undefined) return false;
    if (!('registerName' in value) || value['registerName'] === undefined) return false;
    if (!('registerId' in value) || value['registerId'] === undefined) return false;
    if (!('healthcareFacilityName' in value) || value['healthcareFacilityName'] === undefined) return false;
    if (!('healthcareFacilityId' in value) || value['healthcareFacilityId'] === undefined) return false;
    if (!('countJudgments' in value) || value['countJudgments'] === undefined) return false;
    return true;
}

export function GetReportJudgmentDtoFromJSON(json: any): GetReportJudgmentDto {
    return GetReportJudgmentDtoFromJSONTyped(json, false);
}

export function GetReportJudgmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportJudgmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'psychologistName': json['psychologistName'],
        'psychologistId': json['psychologistId'],
        'registerName': json['registerName'],
        'registerId': json['registerId'],
        'healthcareFacilityName': json['healthcareFacilityName'],
        'healthcareFacilityId': json['healthcareFacilityId'],
        'countJudgments': json['countJudgments'],
    };
}

export function GetReportJudgmentDtoToJSON(value?: GetReportJudgmentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'psychologistName': value['psychologistName'],
        'psychologistId': value['psychologistId'],
        'registerName': value['registerName'],
        'registerId': value['registerId'],
        'healthcareFacilityName': value['healthcareFacilityName'],
        'healthcareFacilityId': value['healthcareFacilityId'],
        'countJudgments': value['countJudgments'],
    };
}

